<template>
  <div class="babyIndex">
      <keep-alive :include='includes' :max="5">
      <router-view></router-view>
      </keep-alive>

  </div>
</template>

<style lang="less" scoped>
.babyIndex{
  min-height: 100%;
  background: @expertBorderColor242;
}
</style>


<script>
import {mapState, mapGetters} from 'vuex'

export default {
  name: "BabyIndex",
  components: {
    
  },
  data() {
    return {};
  },
   computed: {// 在computed中动态监控
     ...mapState({
       includes: state => state.includes, //['Home','BabyList','BabyDetail']
     }),
   },
  mounted() {
    this.gioUserId();
  },
  created() {
   
  },
  methods: {
      
  },
  
};
</script>
